<template>
  <div class="inventory-reconciliation">
    <div class="inventory-reconciliation-search">
      <div class="screen">
        <el-select class="white w200"
          v-model="screen.billHeadId" 
          placeholder="请选择抬头" 
          filterable>
          <el-option v-for="(item, fIndex) in copingWithHeaderList.filter(data => data.status)"
            :key="fIndex" 
            :label="item.customizeName"
            :value="item.id">
          </el-option>
        </el-select>

        <el-select class="white w200" clearable v-model="screen.splitCompleted" placeholder="请选择是否拆分">
          <el-option
            v-for="item in splitCompletedList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-input class="white w240" v-model="screen.billNumber" placeholder="请输入账单编号"></el-input>
        <el-date-picker
          class="w240"
          v-model="screen.date"
          type="daterange"
          start-placeholder="开始结算"
          end-placeholder="结束结算"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
        <el-button class="btn-blue" @click="onScreen">搜索</el-button>
      </div>
    </div>
    
    <DropTable
      ref="reconciliationOfAccountsPayable"
      :columns="tableTitle"
      :data="tableData"
      tableKey="reconciliationOfAccountsPayableList"
      border
      :header-cell-class-name="headerCellClassName"
      :row-key="getKey"
      @selection-change="handleSelectionChange"
    >
      <template slot="action" slot-scope="scope">
        <el-button
          class="btn-text"
          type="text"
          @click="downExcel(scope.row.id)"
        >导出</el-button>
        <el-button
          class="btn-text"
          type="text"
          @click="lookDetails(scope.row)"
        >详情</el-button>
      </template>
    </DropTable>

    <div class="footer">
      <pagination-tpl
        :total="total"
        :currentPage="currentPage"
        :pageSize="pageSize"
        :layout="layout"
        @queryChange="queryChange"
        @onSizeChange="onSizeChange"
      ></pagination-tpl>
    </div>

    
    <div class="footer-table">
      <p>已选{{ billIds.length }}个</p>
      <div>
        <el-button
          class="btn-white"
          @click="autoSplit"
        >
            自动拆分
          </el-button
        >
        <el-button
          class="btn-white"
          @click="handMovementSplit"
        >
            手动拆分
          </el-button
        >
      </div>
    </div>

    
    <!-- 自动/手动拆分预览 -->
    <AutoSplit
      :titleSplit="titleSplit"
      :previewList="previewList"
      :previewTitleList="payPreviewTitleList"
      :previewDialog="previewDialog"
      @onSavePreview="onSavePreview"
      @onClosePreviewDialog="onClosePreviewDialog"
    ></AutoSplit>

    
    <!-- 手动拆分 -->
    <dialogTransfer
      v-if="generateInvoicedDialog"
      :title="title"
      :accountsType="accountsType"
      :projectId="projectId"
      :projectName="projectName"
      :billIds="billIds"
      :generateInvoicedDialog="generateInvoicedDialog"
      :subjectTableTitle="paySubjectTableTitle"
      :generateInvoicedWidth="'1146px'"
      @onCloseGenerateInvoiced="onCloseGenerateInvoiced"
      @onSaveGenerateInvoiced="onSaveGenerateInvoiced"
     ></dialogTransfer>
  </div>
</template>

<script>
import CurrencyMinxins from "common/mixins/currency";
import DropTable from "components/base/DropTable.vue";
import PaginationTpl from "components/base/PaginationTpl";
import { formatTimeToDate, modifyNetTitle } from "common/js/util";
import AutoSplit from '@/components/base/inventory-reconciliation/auto-split.vue'
import dialogTransfer from '@/components/base/inventory-reconciliation/dialog-transfer.vue'
import LookUpMixins from "common/mixins/look-up.js";
import SplitMixins from 'common/mixins/inventory-reconciliation/split'
import InventoryReconciliation from "models/inventory-reconciliation";
import InventoryReconciliationMixins from 'common/mixins/inventory-reconciliation/inventory-reconciliation'
export default {
  mixins: [CurrencyMinxins, InventoryReconciliationMixins, SplitMixins, LookUpMixins],
  data() {
    return {
      //  1：应收 2:应付
      accountsType: 2,
      screen: {
        billHeadId: null,
        splitCompleted: "",
        billNumber: "",
        date: ""
      },
      splitCompletedList: [
        {id:true, name: '是'},
        {id:false, name: '否'}
      ],
      tableData: [],
      tableTitle: [
        {
          checked: true,
          prop: '', 
          label: '',
          type:"selection",
          "reserve-selection":true,
          "width": "55",
          fixed: "left"
        },
        {checked: true, prop: 'billNumber', label: '账单编号', "width": 200},
        {checked: true, prop: 'billHeadName', label: '抬头名称', "min-width": 170},
        {checked: true, prop: 'createTime', label: '生成日期', "width": 120},
        {checked: true, prop: 'settlementCycle', label: '结算周期', "width": 220},
        {checked: true, prop: 'statusVal', label: '账单状态', "width": 100},
        {checked: true, prop: 'currencyVal', label: '币制', "width": 110},
        {checked: true, "class-name":"cell-right-align-width", prop: 'amount', label: '金额', "width": 130},
        { 
          checked: true, 
          label: "操作", 
          prop: "action",
          fixed: "right", 
          "width": "120",
          slotName: "action", // 自定义单元格插槽
        }
      ],
      total: 0,
      currentPage: 1,
      pageSize: 20,
      layout: 'jumper, prev, pager, next, sizes',
      checkSelectable: [],
    };
  },
  components: {
    DropTable,
    AutoSplit,
    dialogTransfer,
    PaginationTpl
  },
  created() {
    modifyNetTitle('进出仓应付对账列表')
    this.getTableData();
    this.initCopingWithHeaderList()
  },
  methods: {
    //获取进出仓应付对账列表
    getTableData() {
      let accountsType = this.accountsType;
      let pageNo = this.currentPage;
      let pageSize = this.pageSize;
      let splitCompleted = this.screen.splitCompleted;
      let billHeadId = this.screen.billHeadId;
      let billNumber = this.screen.billNumber;
      let beginDate = this.screen.date?this.screen.date[0]:''
      let endDate = this.screen.date?this.screen.date[1]:''
      let data = {
        accountsType,
        pageNo,
        pageSize,
        splitCompleted,
        billHeadId,
        billNumber,
        beginDate,
        endDate
      }
      InventoryReconciliation.getInventoryReconciliationList(data).then(res => {
        if (res.success) {
          let tableData = [];
          this.pageSize = res.result.size;
          this.total = res.result.total;
          res.result.records.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.projectId = value.projectId;
            obj.projectName = value.projectName;
            obj.billHeadId = value.billHeadId;
            obj.billHeadName = value.billHeadName;
            obj.billNumber = value.billNumber;
            obj.createTime =  value.createTime ? formatTimeToDate(value.createTime): '';
            obj.settlementCycle = ''
            if (value.balanceBeginDate || value.balanceEndDate) {
              obj.settlementCycle = `${value.balanceBeginDate?value.balanceBeginDate:''}至${value.balanceEndDate?value.balanceEndDate:''}`;
            }
            obj.status = value.status;
            obj.statusVal = value.status === 10?'已结算':'';
            obj.currency = value.currency;
            obj.currencyVal = this.currencySystemObj[value.currency];
            obj.amount = value.amount;
            tableData.push(obj);
          });
          this.tableData = tableData;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    /**
     * @desc 表头添加类名处理数字右对齐
     */
    headerCellClassName({ column}) {
      if (column.property === 'amount') {
        return 'right-align'
      }
    },
    getKey(row) {
      return row.id
    },
    onScreen() {
      this.currentPage = 1;
      this.getTableData();
    },
    //查看详情
    lookDetails(row) {
      let routeData = this.$router.resolve({
        path: '/finance/reconciliation-of-accounts-payable/reconciliation-of-accounts-payable-details',
        query: {
          billHeadId: row.billHeadId,
          billHeadName: row.billHeadName,
          projectId: row.projectId,
          projectName: row.projectName,
          inventoryReconciliationId: row.id
        }
      });
      window.open(routeData.href, '_blank');
    },
    //翻页
    queryChange(data) {
      this.currentPage = data.currentPage;
      this.getTableData();
    },
    onSizeChange(data) {
      this.pageSize = data.pageSize;
      this.getTableData();
    },
    
    handleSelectionChange(val) {
      let arr = []
      // 不同项目
      let isDifferentProject = false
      // 不同币制
      let isDifferentCurrency = false
      val.map(i => {
        if (i.projectId !== val[0].projectId) {
          isDifferentProject = true
          this.$refs.inventoryReconciliationable.toggleRowSelection(i, false)
        } 
        if (i.currency !== val[0].currency) {
          isDifferentCurrency = true
          this.$refs.inventoryReconciliationable.toggleRowSelection(i, false)
        }
        this.projectId = i.projectId
        this.projectName = i.projectName
        this.billHeadId = i.billHeadId
        this.billHeadName = i.billHeadName
        arr.push(i.id)
      })

      if (isDifferentProject) return this.$message.error('不同项目的账单不能多选拆分');
      if (isDifferentCurrency) return this.$message.error('不同币制的账单不能多选拆分');

      this.billIds = arr
    }
  }
};
</script>
<style lang="scss">
.inventory-reconciliation {
  flex: 1;
  background: #fff;
  border-radius: 4px;
  padding: 16px;
  box-sizing: border-box;
  overflow: auto;
  .inventory-reconciliation-search {
    display: flex;
    justify-content: space-between;
    margin-bottom: 16px;
    .screen {
      display: flex;
      .w200 {
        width: 200px;
        margin-right: 16px;
      }
      .w240 {
        width: 240px;
        margin-right: 16px;
      }
    }
  }
  .footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 0 16px;
    margin-bottom: 80px;
  }
  
  .footer-table {
    position: fixed;
    background: white;
    width: calc(100% - 232px);
    bottom: 46px;
    left: 216px;
    height: 66px;
    padding: 0px 32px;
    z-index: 9;
    overflow: hidden;
    border-radius: 0px 0px 8px 8px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-shadow: 0px -3px 12px 0px rgba(51, 51, 51, 0.06);
    p {
      font-family: 'PingFang SC-Regular';
      font-weight: 400;
      font-size: 16px;
      color: #333333;
    }
    .el-button.btn-white:hover {
      border: 0.0625rem solid #2e68ea;
      background: white;
      color: #3d74f2;
    }
  }
  
  .el-table .el-table__body-wrapper .el-table__body tr .cell-right-align-width{
    .cell {
      width: 120px !important;
      text-align: right;
      padding-right: 6px;
    }
  }
  .el-table .el-table__header-wrapper .el-table__header tr th.right-align {
    .cell {
      width: 130px !important;
      text-align: right;
    }
  }
  
  .el-checkbox__input.is-focus .el-checkbox__inner,
  .el-checkbox__inner:hover {
    border-color: #2E68EA;
  }
  .el-checkbox__input.is-checked .el-checkbox__inner, 
  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #2E68EA;
    border-color: #2E68EA;
  }
}
</style>
